module.exports = __webpack_public_path__ + "static/img/xunyuan-bg.39f87ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/srmCloud/xunyuan-bg.png
// module id = 480
// module chunks = 12